import { useState } from 'react';
import { Check, Copy, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const HTACCESS_SNIPPET = `# BEGIN CMS Hub — Authorization header passthrough
<IfModule mod_rewrite.c>
    RewriteEngine On
    RewriteRule .* - [E=HTTP_AUTHORIZATION:%{HTTP:Authorization}]
</IfModule>
# LiteSpeed (cPanel'de yaygın) için:
<IfModule LiteSpeed>
    CGIPassAuth On
</IfModule>
# END CMS Hub`;

export function HtaccessHelper() {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    await navigator.clipboard.writeText(HTACCESS_SNIPPET);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div className="space-y-2 rounded-md border border-amber-200 bg-amber-50 dark:border-amber-900/40 dark:bg-amber-950/30 p-3">
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
        <div className="text-sm flex-1">
          <p className="font-medium text-foreground">Authorization header iletilmiyor</p>
          <p className="text-xs text-muted-foreground mt-1">
            Sunucunuz Authorization header'ı PHP'ye iletmiyor. cPanel/LiteSpeed ve bazı Apache
            kurulumlarında yaygın. WP kök dizinindeki{' '}
            <code className="px-1 py-0.5 bg-background rounded text-[11px]">.htaccess</code>{' '}
            dosyasının <strong>en üstüne</strong> aşağıdaki snippet'i ekleyin:
          </p>
        </div>
        <Button size="sm" variant="outline" type="button" onClick={onCopy}>
          {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
          {copied ? 'Kopyalandı' : 'Kopyala'}
        </Button>
      </div>
      <pre className="text-[11px] font-mono bg-background rounded-md p-3 overflow-x-auto leading-relaxed">
        {HTACCESS_SNIPPET}
      </pre>
      <p className="text-xs text-muted-foreground">
        Snippet eklendikten sonra tekrar <strong>Bağlantıyı Test Et</strong> butonuna bas.
      </p>
    </div>
  );
}
